import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRICE_FULL, PRICE_TODAY, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function PricingCard() {
  return <section id="offerta" className="border-y-2 border-brand-orange/50 bg-brand-cream px-4 py-5" data-id="element-103" data-mp="1m4t9m0pdxwce">
      <div className="mx-auto max-w-2xl" data-id="element-104" data-mp="1i4aik8vbgub9">
        <div className="mb-2 text-center" data-id="element-105" data-mp="2esytkl8m7hb6">
          <p className="mb-1 font-display text-[11px] font-semibold uppercase tracking-widest text-brand-orange sm:text-sm" data-id="element-106" data-mp="2ernis1gr59ak">
            Offerta speciale di lancio
          </p>
          <h2 className="mb-0.5 font-display text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-107" data-mp="252dqakhzxolx">
            SMART HOME PRO™
          </h2>
          <p className="mb-2 font-display text-[13px] font-semibold text-brand-ink sm:text-base" data-id="element-108" data-mp="20zhepdqvisrh">
            Sistema Completo 6-in-1 per la Domotica
          </p>
          <a href={CHECKOUT_URL} className="block" aria-label="Acquista SMART HOME PRO™" data-id="element-109" data-mp="2sror21zcjj02">
            <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto mb-2 w-full max-w-[230px] object-contain drop-shadow-xl transition-transform duration-200 ease-out hover:scale-[1.02] sm:max-w-[260px]" data-id="element-110" data-mp="32ldkl1xbuwt2" />
          </a>
        </div>

        <div className="mb-2 rounded-2xl border-4 border-brand-orange bg-white p-4 text-center shadow-2xl" data-id="element-111" data-mp="2xsu868adm7pu">
          <ul className="mb-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-0.5 text-[13px] font-semibold text-brand-ink sm:text-base" data-id="element-112" data-mp="2jst64pidku8s">
            <li data-id="element-113" data-mp="2oqky1jj0sgcz">✅ 6 Moduli Completi</li>
            <li data-id="element-114" data-mp="29wgfk0i4mwi9">✅ 5 Bonus Premium</li>
          </ul>
          <p className="mb-0.5 text-[13px] font-medium text-brand-muted" data-id="element-115" data-mp="29xrk42jec8af">
            Prezzo Regolare: <span className="line-through" data-id="element-116" data-mp="2euzz5u98zw7g">{PRICE_FULL}</span>
          </p>
          <p className="font-display text-base font-extrabold uppercase tracking-wide text-brand-orange sm:text-2xl" data-id="element-117" data-mp="85lf2vcz6957">
            🔥 SOLO OGGI: {PRICE_TODAY}
          </p>
          <p className="mb-3 text-[11px] font-medium text-brand-muted" data-id="element-118" data-mp="bmr2h616rkuq">
            Pagamento sicuro nella tua valuta locale.
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-119" data-mp="6ljvh96vapp4">🚀 SÌ! VOGLIO SMART HOME PRO™</CTAButton>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-brand-ink sm:text-sm" data-id="element-120" data-mp="1ojwfi8fqn7i">
          <span className="flex items-center gap-1" data-id="element-121" data-mp="ucpic8b86i8x">
            <StarIcon className="h-4 w-4 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-122" data-mp="ube7jojd4a8b" />
            ⭐⭐⭐⭐⭐ 4,9/5 — Recensioni Verificate
          </span>
          <span className="flex items-center gap-1" data-id="element-123" data-mp="kmnsbazbaprd">
            <ShieldCheckIcon className="h-4 w-4 text-brand-orange" aria-hidden="true" data-id="element-124" data-mp="kl31nwg4bqys" />
            🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni
          </span>
        </div>
      </div>
    </section>;
}